// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-list {
  width: 95%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 5%;
  padding: 1%;
  background-color: #fff;
}

.activities-list {
  width: 95%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 5%;
  padding: 1%;
  background-color: #fff;
}

.data-table {
  display: flex;
  justify-content: space-between;
}
.contAddUsers .users {
  font-size: 18px;
  font-weight: 600;
  color: #73879c;
  padding: 5px;
  margin: 0;
}

.contAddUsers {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.btn-users {
  display: flex;
}

.adduser {
  font-size: 13px;
  color: #73879c;
  background-color: #c3c6c9;
  border: 1px solid #a3a7aa;
  text-decoration: none;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  padding: 5px;
  margin-left: 10px;
}

.adduser:hover {
  background-color: #a3a7aa;
}

.adduser i {
  font-size: 15px;
  margin-right: 5px;
}

.user-row th {
  color: #73879c;
  font-size: 15px;
  font-weight: 600;
}

.user-row td {
  color: #73879c;
  font-size: 14px;
}

.data-text {
  margin: 0;
  display: flex;
  /* justify-content: flex-start; */
}

.enable-user {
  background-color: rgba(99, 241, 123, 0.274);
  color: rgb(13, 145, 35);
  width: 90%;
  display: flex;
  justify-content: center;
}

.disable-user {
  background-color: rgba(177, 39, 58, 0.274);
  color: rgb(155, 20, 38);
  width: 90%;
  display: flex;
  justify-content: center;
}

.inworks {
  background-color: rgba(177, 168, 39, 0.274);
  color: rgb(155, 133, 20);
  width: 90%;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .enable-user {
    width: 80%;
  }
  .disable-user {
    width: 80%;
  }
}

/* para eliminar bordes de columnas */
table.table.table-bordered {
  border-collapse: collapse;
  border: none;
}

table.table.table-bordered th,
table.table.table-bordered td {
  border: none;
}

.user-row {
  border: 1px solid #cfcfcf;
}

/* botones de actions */
.btnUser-edit {
  display: flex;
  justify-content: space-around !important;
  align-items: center;
  color: #fff;
  background-color: #5bc0de;
  border: 1px solid #46b8da;
  border-radius: 3px;
  padding: 1px 5px;
  margin-right: 2px;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}
.btnUser-edit:hover {
  color: #fff;
  background-color: #52acc7;
  border-color: #adadad;
}

.btnUser-delete {
  display: flex;
  justify-content: space-around !important;
  align-items: center;
  color: #fff;
  background-color: #d9534f;
  border: 1px solid #d43f3a;
  border-radius: 3px;
  padding: 1px 5px;
  margin-right: 2px;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

.btnUser-delete:hover {
  color: #fff;
  background-color: #c53b36;
  border-color: #adadad;
}

.btnUser-delete p {
  text-decoration: none;
  color: #fff;
}

.cont-actions {
  display: flex;
}

.cont-actions p {
  display: flex;
  margin: 0;
  text-decoration: none;
}

.cont-back-activity {
  width: 7%;
}

.cont-back-users {
  width: 7%;
}

.supoffice-status {
  display: flex;
  cursor: pointer;
}

.icon-info {
  cursor: pointer;
  color: #73879c;
}

.supplier-column {
  width: 30%;
}

.select-supplier {
  cursor: pointer;
  color: #73879c;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users/Users.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,UAAU;AACZ","sourcesContent":[".users-list {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  margin-bottom: 5%;\n  padding: 1%;\n  background-color: #fff;\n}\n\n.activities-list {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  margin-bottom: 5%;\n  padding: 1%;\n  background-color: #fff;\n}\n\n.data-table {\n  display: flex;\n  justify-content: space-between;\n}\n.contAddUsers .users {\n  font-size: 18px;\n  font-weight: 600;\n  color: #73879c;\n  padding: 5px;\n  margin: 0;\n}\n\n.contAddUsers {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.btn-users {\n  display: flex;\n}\n\n.adduser {\n  font-size: 13px;\n  color: #73879c;\n  background-color: #c3c6c9;\n  border: 1px solid #a3a7aa;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  cursor: pointer;\n  padding: 5px;\n  margin-left: 10px;\n}\n\n.adduser:hover {\n  background-color: #a3a7aa;\n}\n\n.adduser i {\n  font-size: 15px;\n  margin-right: 5px;\n}\n\n.user-row th {\n  color: #73879c;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.user-row td {\n  color: #73879c;\n  font-size: 14px;\n}\n\n.data-text {\n  margin: 0;\n  display: flex;\n  /* justify-content: flex-start; */\n}\n\n.enable-user {\n  background-color: rgba(99, 241, 123, 0.274);\n  color: rgb(13, 145, 35);\n  width: 90%;\n  display: flex;\n  justify-content: center;\n}\n\n.disable-user {\n  background-color: rgba(177, 39, 58, 0.274);\n  color: rgb(155, 20, 38);\n  width: 90%;\n  display: flex;\n  justify-content: center;\n}\n\n.inworks {\n  background-color: rgba(177, 168, 39, 0.274);\n  color: rgb(155, 133, 20);\n  width: 90%;\n  display: flex;\n  justify-content: center;\n}\n\n@media (max-width: 768px) {\n  .enable-user {\n    width: 80%;\n  }\n  .disable-user {\n    width: 80%;\n  }\n}\n\n/* para eliminar bordes de columnas */\ntable.table.table-bordered {\n  border-collapse: collapse;\n  border: none;\n}\n\ntable.table.table-bordered th,\ntable.table.table-bordered td {\n  border: none;\n}\n\n.user-row {\n  border: 1px solid #cfcfcf;\n}\n\n/* botones de actions */\n.btnUser-edit {\n  display: flex;\n  justify-content: space-around !important;\n  align-items: center;\n  color: #fff;\n  background-color: #5bc0de;\n  border: 1px solid #46b8da;\n  border-radius: 3px;\n  padding: 1px 5px;\n  margin-right: 2px;\n  font-size: 12px;\n  line-height: 1.5;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  touch-action: manipulation;\n  cursor: pointer;\n}\n.btnUser-edit:hover {\n  color: #fff;\n  background-color: #52acc7;\n  border-color: #adadad;\n}\n\n.btnUser-delete {\n  display: flex;\n  justify-content: space-around !important;\n  align-items: center;\n  color: #fff;\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n  border-radius: 3px;\n  padding: 1px 5px;\n  margin-right: 2px;\n  font-size: 12px;\n  line-height: 1.5;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  touch-action: manipulation;\n  cursor: pointer;\n}\n\n.btnUser-delete:hover {\n  color: #fff;\n  background-color: #c53b36;\n  border-color: #adadad;\n}\n\n.btnUser-delete p {\n  text-decoration: none;\n  color: #fff;\n}\n\n.cont-actions {\n  display: flex;\n}\n\n.cont-actions p {\n  display: flex;\n  margin: 0;\n  text-decoration: none;\n}\n\n.cont-back-activity {\n  width: 7%;\n}\n\n.cont-back-users {\n  width: 7%;\n}\n\n.supoffice-status {\n  display: flex;\n  cursor: pointer;\n}\n\n.icon-info {\n  cursor: pointer;\n  color: #73879c;\n}\n\n.supplier-column {\n  width: 30%;\n}\n\n.select-supplier {\n  cursor: pointer;\n  color: #73879c;\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
